import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { ApiService } from './api.service';
import { StorageService } from './storage.service';
import { NgxSpinnerService } from "ngx-spinner";
import { MatSnackBar } from '@angular/material/snack-bar';
import { firstValueFrom } from 'rxjs';
import { ChatService } from './chat.service';
import { environment } from '../../environments/environment';

declare var Razorpay: any;

@Injectable({
  providedIn: 'root'
})
export class PaymentService {
  details: any;
  isSuccess: string = "failed";
  booking_id: any;
  amount: any;
  payment_method: any;
  razorpay_order_id: any;
  comments: any;
  status: any;
  razorpayKey: any;
  constructor(private spinner: NgxSpinnerService, private router: Router, private apiService: ApiService, private storage: StorageService, private snackBar: MatSnackBar, private chatService: ChatService) { }

  // Fetch Razorpay key
  async getRazorpayKey(): Promise<string | null> {
    if (this.razorpayKey) {
      return this.razorpayKey;
    }

    const storedKey = this.storage.get('km_user_razorpay_key');
    const expectedPrefix = environment.production ? 'rzp_live_' : 'rzp_test_';
    if (storedKey?.startsWith(expectedPrefix)) {
      this.razorpayKey = storedKey;
      return this.razorpayKey;
    }
    if (storedKey) {
      this.storage.remove('km_user_razorpay_key');
    }

    try {
      const response: any = await firstValueFrom(this.apiService.getRazorpayKey());
      if (response?.success && response.data?.key?.startsWith(expectedPrefix)) {
        this.razorpayKey = response.data.key;
        this.storage.set('km_user_razorpay_key', this.razorpayKey);
        return this.razorpayKey;
      }
      this.snackBar.open(`Invalid ${environment.production ? 'live' : 'test'} Razorpay key returned by the server.`, 'Close', {
        duration: 4000,
        horizontalPosition: 'center',
        verticalPosition: 'top'
      });
    } catch (err: any) {
      this.snackBar.open(err?.error?.message || 'Unable to load payment configuration.', 'Close', {
        duration: 2000,
        horizontalPosition: 'center',
        verticalPosition: 'top',
        panelClass: ['green-snackbar']
      });
    }

    return null;
  }

  async pay(details: any) {
    this.details = details;
    const razorpayKey = await this.getRazorpayKey();
    if (!razorpayKey) {
      return;
    }

    let razorpayOptions = {
      // "key": "rzp_test_wBtIO7H9k3BjFk",
      "key": razorpayKey,
      "amount": details.amount * 100,
      "currency": "INR",
      "name": "Medease",
      "description": "Slot Booking",
      "order_id": details.order_id,
      "retry": false,
      "handler": (res: any) => {
      },
      modal: {
        ondismiss: function () {
        }
      }
    };
    var cancelCallBack = (response: any) => {
      this.isSuccess = "failed";
      // Data for passing to the payment log Api Call
      const paymentLogData = {
        booking_id: this.details.booking_id,
        amount: this.details.amount,
        payment_method: this.details.payment_method,
        razorpay_order_id: this.details.order_id,
        comments: "payment failed",
        status: 0
      };

      if(paymentLogData) {
        this.apiService.paymentLog(paymentLogData).subscribe({
          next: (response: any) => {
            if ((response["success"])) {
            } else {
            }
          },
          error: (err: any) => {
          },
          complete: () => { }
        });
      }

      this.details = { ...this.details, ...response };
      this.storage.set('booking_response', JSON.stringify(this.details));
      // this.router.navigate(['/booking-status', this.isSuccess], { replaceUrl: true });
      this.router.navigate(['/booking-status', this.isSuccess], { 
        replaceUrl: true,
        fragment: 'success-section'
      });
    };
    var razorpayResponseHandler = async (response: any) => {
      this.spinner.show();
      this.details = { ...this.details, ...response };
      this.storage.set('booking_details', JSON.stringify(this.details));
      await this.apiService.bookingConfirm(this.details).then(
        (data: any) => {
          if (data["success"]) {
            this.isSuccess = "success";
            this.storage.set('booking_response', JSON.stringify(data));
            this.chatService.resetAfterPayment();
            // this.router.navigate(['/booking-status', this.isSuccess], { replaceUrl: true });
            this.router.navigate(['/booking-status', this.isSuccess], { 
              replaceUrl: true,
              fragment: 'success-section'
            });
            this.spinner.hide();
          } else {
            this.isSuccess = "failed";
            this.storage.set('booking_response', JSON.stringify(data));
            // this.router.navigate(['/booking-status', this.isSuccess], { replaceUrl: true });
            this.router.navigate(['/booking-status', this.isSuccess], { 
              replaceUrl: true,
              fragment: 'success-section'
            });
          }
        },
        (error: any) => {
          this.isSuccess = "failed";
          this.storage.set('booking_response', JSON.stringify(error));
          // this.router.navigate(['/booking-status', this.isSuccess], { replaceUrl: true });
          this.router.navigate(['/booking-status', this.isSuccess], { 
            replaceUrl: true,
            fragment: 'success-section'
          });
        }
        
      );
    };
    razorpayOptions.handler = razorpayResponseHandler;
    var rzp1 = new Razorpay(razorpayOptions);
    rzp1.on('payment.failed', cancelCallBack);
    rzp1.open();


  }


}
